import { useTranslation } from "react-i18next";
import Container from "../components/common/Container";
import Title from "../components/common/Title";
import Content from "../components/common/Content";
import Navigation from "../components/ui/Navigation";
import BrainVisual from "../components/ui/BrainVisual";
import styled from "styled-components";

const Introduction = styled.div`
  border-top: 1px solid #ddd;
  padding: 15px;
`;

export default () => {
  const { t } = useTranslation("home");
  return (
    <>
      <Title>{t("title")}</Title>
      <Container>
        <Content>
          <BrainVisual />
          <Navigation />
        </Content>
        <Content>
          <Introduction>
            <Title>{t("subtitle")}</Title>
            <p>{t("intro")}</p>
            <p>
              {t("closure_first")} <strong>{t("closure_fat")}</strong>
              {t("closure_last")}
            </p>
          </Introduction>
        </Content>
      </Container>
    </>
  );
};
